import * as tslib_1 from "tslib";
import { Risk } from './risk.model';
import { DataStorage } from './data-storage.model';
var PersonalAccidentsStorage = /** @class */ (function (_super) {
    tslib_1.__extends(PersonalAccidentsStorage, _super);
    function PersonalAccidentsStorage() {
        var _this = _super.call(this) || this;
        _this.branch = 7;
        _this.insureds = [];
        _this.risk = new Risk();
        return _this;
    }
    return PersonalAccidentsStorage;
}(DataStorage));
export { PersonalAccidentsStorage };
